---
title: What to Log When Fishing
description: What actually matters when logging a fishing trip.
---

# What to Log When Fishing

Short logs are better than perfect logs.

Log:
- Time window
- Location type
- Gear used
- Outcome

Skip:
- Guessing
- Over-analysis
- Pressure

Consistency beats detail.

If you’re just starting out, it helps to review the full
[beginner fishing tips](/learn/beginner-fishing-tips) guide.

---

### Keep learning
- [Fishing techniques](/learn/techniques)
- [Species guides](/learn/species)
- [Fishing regions](/learn/regions)
- [Roddo Learn hub](/learn)
